import clsx from 'clsx';
import styles from './AspectRatio.module.scss';

export interface AspectRatioProps
    extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    ratio: string;
}

export const AspectRatio = ({ children, className, ratio, style, ...rest }: AspectRatioProps) => {
    return (
        <div
            className={clsx(styles.component, className)}
            style={{ ...style, '--aspectRatio': ratio } as React.CSSProperties}
            {...rest}
        >
            {children}
        </div>
    );
};
